import MiniSearch from 'minisearch'

let miniSearch = null

async function loadIndex() {
  if (miniSearch) return miniSearch

  const res = await fetch('/search.json', { cache: 'no-store' })
  const documents = await res.json()

  miniSearch = new MiniSearch({
    fields: ['title', 'summary', 'content'],
    storeFields: ['title', 'url', 'summary'],
    searchOptions: {
      boost: { title: 3, summary: 2, content: 1 },
      prefix: true,
      fuzzy: 0.2
    },
    tokenize: (string) =>
      string
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .split(/[^a-z0-9]+/i)
        .filter(Boolean)
  })

  miniSearch.addAll(documents)
  return miniSearch
}

export async function searchSite(query) {
  if (!query || query.trim().length === 0) return []
  const ms = await loadIndex()
  return ms.search(query)
}

export function attachSearchHandlers({
  inputSelector = '#site-search',
  resultsSelector = '#search-results',
  isDropdown = false
} = {}) {
  const input = document.querySelector(inputSelector)
  const resultsBox = document.querySelector(resultsSelector)

  if (!input || !resultsBox) return

  let lastQuery = ''

  const doSearch = async (q) => {
    if (q === lastQuery) return
    lastQuery = q

    if (!q) {
      resultsBox.innerHTML = ''
      if (isDropdown) resultsBox.style.display = 'none'
      return
    }

    const hits = await searchSite(q)

    if (hits.length === 0) {
      resultsBox.innerHTML = '<div class="p-3 text-muted">Aucun résultat trouvé</div>'
    } else {
      resultsBox.innerHTML = hits.slice(0, 10).map(hit => `
        <a href="${hit.url}" class="list-group-item list-group-item-action">
          <strong>${escapeHtml(hit.title || '')}</strong><br>
          <small class="text-muted">${snippet(hit.summary || '', q, 100)}</small>
        </a>
      `).join('')
    }

    if (isDropdown) resultsBox.style.display = 'block'
  }

  input.addEventListener('input', (e) => doSearch(e.target.value.trim()))

  // Hide dropdown on click outside
  if (isDropdown) {
    document.addEventListener('click', (e) => {
      if (!input.contains(e.target) && !resultsBox.contains(e.target)) {
        resultsBox.style.display = 'none'
      }
    })
    input.addEventListener('focus', () => {
      if (lastQuery) resultsBox.style.display = 'block'
    })
  }

  // Check URL params for initial query (search page)
  const urlParams = new URLSearchParams(window.location.search)
  const initialQuery = urlParams.get('q')
  if (initialQuery) {
    input.value = initialQuery
    doSearch(initialQuery)
  }
}

function escapeHtml(s) {
  return s.replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]))
}

function snippet(text, query, max = 160) {
  if (!text) return ''
  const idx = text.toLowerCase().indexOf(query.toLowerCase())
  if (idx < 0) return text.slice(0, max) + (text.length > max ? '…' : '')
  const start = Math.max(0, idx - Math.floor(max/3))
  const end = Math.min(text.length, start + max)
  return (start > 0 ? '…' : '') + text.slice(start, end) + (end < text.length ? '…' : '')
}
